import { render, staticRenderFns } from "./historyScore.vue?vue&type=template&id=90e12650&scoped=true&"
import script from "./historyScore.vue?vue&type=script&lang=js&"
export * from "./historyScore.vue?vue&type=script&lang=js&"
import style0 from "./historyScore.vue?vue&type=style&index=0&id=90e12650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e12650",
  null
  
)

export default component.exports